import { Navigate } from "react-router-dom";
import { useAuth } from "../state/AuthContext";
import { LOCAL_SEED } from "../data/localSeed";
import { PageHeader } from "../components/RequestRouting";

export function BenefitsPage() {
  const { moduleIds, homePath } = useAuth();
  if (!moduleIds.includes("benefits")) return <Navigate to={homePath} replace />;

  const oe = LOCAL_SEED.open_enrollment?.[0];
  const plans = LOCAL_SEED.benefits ?? [];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Benefits"
        subtitle="Open enrollment windows and your benefit plan enrollments."
      />

      <div className="bg-white border border-black/5 p-4 space-y-2">
        <h2 className="font-semibold text-navy">Open enrollment</h2>
        {oe ? (
          <>
            <div className="text-2xl font-semibold text-navy">{String(oe.status)}</div>
            <p className="text-sm text-slate">Last window: {String(oe.window)}</p>
            <p className="text-sm text-slate">Next: {String(oe.next_window)}</p>
          </>
        ) : (
          <p className="text-sm text-slate">No enrollment window on file.</p>
        )}
      </div>

      <div className="bg-white border border-black/5 overflow-hidden">
        <div className="px-4 py-3 border-b border-black/5 font-semibold text-navy">
          Your enrollments
        </div>
        <table className="w-full text-sm">
          <thead className="bg-mist">
            <tr>
              <th className="text-left px-3 py-2 text-slate">Plan</th>
              <th className="text-left px-3 py-2 text-slate">Status</th>
              <th className="text-left px-3 py-2 text-slate">Coverage</th>
            </tr>
          </thead>
          <tbody>
            {plans.map((b) => (
              <tr key={String(b.id)} className="border-t border-black/5">
                <td className="px-3 py-2">{String(b.plan)}</td>
                <td className="px-3 py-2">{String(b.status)}</td>
                <td className="px-3 py-2">{String(b.coverage)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
